// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2rysR","col":"Table_col__22ICC","fulfillmentStatus":"Table_fulfillmentStatus__38sZD","emailCol":"Table_emailCol__3miUZ"};